import { ConfigContent } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/components/config-content';
import { ContactDetailTabs } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/components/contact-detail-tabs';
import { useContactDetailsConfig } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/context';
import { TabContext } from '@mui/lab';
import { Button, Divider, Stack } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import { ProfileDetailsCardProps } from './types';

export const ProfileDetailsCard = memo(
  ({ limitedItems }: ProfileDetailsCardProps) => {
    const { activeTab, showFullItems, setShowFullItems, showSeeMore } =
      useContactDetailsConfig();

    const handleSeeMore = () => {
      setShowFullItems(!showFullItems);
    };

    return (
      <TabContext value={activeTab.toString()}>
        <Stack>
          <ContactDetailTabs />
          <Divider />
        </Stack>

        <ConfigContent limitedItems={limitedItems} sx={SX.configContent} />

        {showSeeMore && (
          <Button
            variant="text"
            color="primary"
            onClick={handleSeeMore}
            sx={{ marginTop: 0.5 }}
          >
            {showFullItems ? 'Show less' : 'Show more'}
          </Button>
        )}
      </TabContext>
    );
  }
);
